import React, { useEffect, useState } from 'react'
import Container from '@mui/material/Container';
import Footer from 'components/Footer';
import Header from 'components/Header';
import { Outlet } from "react-router-dom";
import axiosInstance from 'interceptor/axiosInstance';
import { GlobalHeader } from 'types/cms/GlobalHeader';
import { GlobalFooter } from 'types/cms/GlobalFooter';

const Layout = ({ lmpRef }: any) => {
  const [headerData, setHeaderData] = useState<GlobalHeader | null>(null)
  const [footerData, setFooterData] = useState<GlobalFooter | null>(null)
  useEffect(() => {
    axiosInstance.get('/globals/header?depth=1&draft=false&locale=undefined').then((response) => {
      setHeaderData(response.data)
    }).catch((error) => {
      console.log(error)
    })

    axiosInstance.get('/globals/footer?depth=1&draft=false&locale=undefined').then((response) => {
      setFooterData(response.data)
    }).catch((error) => {
      console.log(error)
    })
  }, [])

  if (!headerData || !footerData) {
    return null;
  }

  return (
    <Container maxWidth="xl" sx={{ mt: 7 }}>
      <Header headerData={headerData} />
      <Outlet />
      <Footer footerData={footerData} />
    </Container>
  )
};

export default Layout;
